import { useDataSubmit, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'steps',
    viewPath: props.viewPath,
  })
  return function onClick() {
    submit({
      type: 'changeStatus',
      value: 'completed',
    })
  }
}

export function useIsDisabled(props) {
  let value = useDataValue({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return !validate(value)
}

function validate(value) {
  return value.step_type === 'automation'
    ? isAutomationValid(value.event)
    : true
}

function isAutomationValid(event) {
  switch (event.type) {
    case 'APPOINTMENT_BOOKING_STATE_UPDATE': {
      return (
        event.data.appointmentTypeIds.length > 0 &&
        event.data.valueTo.length > 0
      )
    }
    case 'TREATMENT_STATUS_UPDATE': {
      return event.data.valueTo.length > 0
    }
    case 'RESOURCE_INSERT': {
      return event.actionData.taskBasketId
    }
    default: {
      return true
    }
  }
}
